import React, { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Button, julo, Typography } from '@julo-ui/react';
import { errorContainerCss } from './styles';
import errorFallbackImage from '../../assets/error-fallback.png';
import Header from 'components/Header';
import { useActionLog } from '@hooks/use-action-log';

interface ErrorFallbackProps extends FallbackProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
  title = 'Muat ulang halaman ini, ya!',
  subtitle = 'Maaf, terjadi kendala saat memuat halaman ini. Silakan muat ulang untuk lanjutkan proses, ya.',
  buttonText = 'Muat Ulang Halaman',
}) => {
  const { pushEvent } = useActionLog();

  useEffect(() => {
    // Log error boundary view with error details
    pushEvent({
      event: 'view',
      element: 'view_error_boundary',
      module: 'crash_page',
      attributes: {
        error_message: error?.message || 'Unknown error',
        error_name: error?.name || 'Error',
        error_stack: error?.stack || '',
      },
    });
  }, [pushEvent, error]);

  const handleReload = () => {
    pushEvent({
      event: 'click',
      element: 'click_reload_error_boundary',
      module: 'crash_page',
      attributes: {
        error_message: error?.message || 'Unknown error',
        error_name: error?.name || 'Error',
        error_stack: error?.stack || '',
      },
    });

    // set delay 200ms for api call
    setTimeout(resetErrorBoundary, 200);
  };

  return (
    <julo.div className={errorContainerCss}>
      <Header />
      <img src={errorFallbackImage} alt='Error' />

      <Typography
        type='heading'
        headingType={6}
        color='var(--colors-primary-30)'
        bold
        fontSize='16px'
        lineHeight='1'
      >
        {title}
      </Typography>

      <Typography type='body' color='var(--colors-neutrals-80)' fontSize='14px'>
        {subtitle}
      </Typography>

      <Button onClick={handleReload}>{buttonText}</Button>
    </julo.div>
  );
};

export default ErrorFallback;
